import { Component, OnInit } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown'
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../Services/auth.service';
import { ApiService } from '../Services/api.service';
import { ToastModule } from 'primeng/toast';
import { ToastService } from '../Services/toast.service';
import { MaterialModule } from '../material';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [
    InputTextModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    InputMaskModule,
    TranslateModule,
    ReactiveFormsModule,
    ToastModule,
    MaterialModule,
    CommonModule],
  providers: [AuthService, ApiService, ToastService, TranslateService],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css'
})
export class ContactComponent implements OnInit {
  contactForm!: FormGroup;
  providerId: string;
  assuredData: any;
  isLoading: boolean | false;
  username : string;
  contactFormSubmitted = false; 
  constructor(private fb: FormBuilder, private authService: AuthService, private apiService: ApiService<any>, private toastService: ToastService, private translateService:TranslateService) { }
  ngOnInit() {
    this. getSessionDetails()
    this.getAssuredPersonDetails()
    this.providerId = this.authService.getCurrentUserPID()
    this.contactForm = this.fb.group({
      fullName: [this.username, Validators.required],
      phoneNumber: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      messageBody: ['', Validators.required]
    });
  }

  onSubmit() {
    this.isLoading = true;
    this.contactFormSubmitted = true;

    if (this.contactForm.valid) {
      let contactData = {
        ...this.contactForm.value,
        providerId: Number(this.providerId),
      };
      this.apiService.create(`api/ContactUs/ContactUs`, contactData).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.translateService.get('toast.messagesent').subscribe(text => this.toastService.showSuccess(text));

        },
        error: (error: any) => {
          this.isLoading = false;
          this.toastService.showError(error);
        }
      });
    } else {
      this.isLoading = false;
      this.contactForm.markAllAsTouched();
      this.translateService.get('toast.fillinallthefields').subscribe(text => this.toastService.showError(text));

    }
  }

  getAssuredPersonDetails() {
    this.apiService.getAll(`api/ContactUs/GetCompanyDetails`).subscribe({
      next: (response: any) => {
        this.assuredData = response.successResponse;
      },
      error: (error: any) => {
        this.toastService.showError(error)
      }
    })
  }

  getSessionDetails(){
    this.username = this.authService.getUserName()
  }

}
